import { list } from "@mc/mc-legacy";
import QSignAdminApi from "../api/gen/qsign/QSignAdminApi";
export const SIGNER_LIST = "signerList";
// QSIGN fetch šablony
export function fetchSignersIfNeeded(force = false) {
  return (dispatch, getState) => {
    dispatch(
      list.SimpleListActions.fetchIfNeeded(
        SIGNER_LIST,
        null,
        (parent, filter) => {
          return QSignAdminApi.findSigners({fulltext: ""});
        },
        force
      )
    );
  };
}
